// src/locales/en/productTags.js
export const productTags = {
  // Page titles and descriptions
  title: "Product Tags",
  description: "Manage product tags to organize and categorize your products effectively",
  
  // Navigation
  addTag: "Add Tag",
  createNewTag: "Create New Tag",
  editTag: "Edit Tag",
  createFirstTag: "Create First Tag",
  
  // Form Fields
  tagName: "Tag Name",
  tagNamePlaceholder: "Enter tag name (e.g., New Arrival, Best Seller, Sale)",
  
  // Table Headers
  name: "Name",
  createdAt: "Created",
  updatedAt: "Last Updated",
  
  // Search and Filter
  searchTags: "Search tags by name...",
  filteredResults: "{{count}} of {{total}} tags",
  totalTags: "{{count}} tags",
  
  // Validation Messages
  nameRequired: "Tag name is required",
  nameMinLength: "Tag name must be at least 2 characters",
  nameMaxLength: "Tag name cannot exceed 50 characters",
  
  // Actions
  createTag: "Create Tag",
  updateTag: "Update Tag",
  saveChanges: "Save Changes",
  
  // Success/Error Messages
  tagCreatedSuccess: "Tag '{{tagName}}' created successfully!",
  tagUpdatedSuccess: "Tag '{{tagName}}' updated successfully!",
  tagDeletedSuccess: "Tag '{{tagName}}' has been deleted successfully.",
  failedToCreate: "Failed to create tag. Please try again.",
  failedToUpdate: "Failed to update tag. Please try again.",
  failedToDelete: "Failed to delete tag. Please try again.",
  failedToLoadTag: "Failed to load tag details. Please try again.",
  failedToLoadTags: "Failed to load tags. Please try again.",
  
  // Loading states
  loadingTags: "Loading Tags...",
  loadingTagsDesc: "Please wait while we fetch your product tags.",
  savingTag: "Saving tag...",
  deletingTag: "Deleting tag...",
  
  // Empty states
  noTags: "No tags yet",
  noTagsDesc: "Create your first product tag to start organizing your products with labels and categories.",
  noSearchResults: "No tags found",
  noSearchResultsDesc: "Try adjusting your search terms or clear filters to see all tags.",
  
  // Confirmation dialogs
  confirmDelete: "Are you sure you want to delete the tag '{{tagName}}'? This action cannot be undone and may affect products using this tag.",
  confirmDeleteTitle: "Delete Tag",
  
  // Status and metadata
  createdDate: "Created on {{date}}",
  updatedDate: "Last updated on {{date}}",
  businessTag: "Business Tag",
  
  // Form validation hints
  nameHint: "Use descriptive names that help categorize your products (e.g., 'Seasonal', 'Featured', 'Clearance')",
  duplicateNameError: "A tag with this name already exists",
  
  // Sorting
  sortBy: "Sort by",
  sortByName: "Name",
  sortByCreated: "Created Date",
  sortByUpdated: "Updated Date",
  ascending: "Ascending",
  descending: "Descending"
};